import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { fonts, spacing } = theme;

export const root = css`
  display: inline-flex;
  column-gap: ${spacing.base}px;
  border: 0 none;
  padding: 0;
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  color: inherit;
  background-color: transparent;

  &:hover {
    cursor: pointer;
  }
`;
